// extracted by mini-css-extract-plugin
export var horizontal = "social-icons-module--horizontal--QPCEU";
export var vertical = "social-icons-module--vertical--aPfQh";
export var fixed = "social-icons-module--fixed--PPw6N";
export var facebook = "social-icons-module--facebook--LCL4z";
export var linkedIn = "social-icons-module--linkedIn--guy6m";
export var twitter = "social-icons-module--twitter--5E1Wj";